<template>
    <div class="pl-5">
        <h1>TarkPay plugins</h1>
        <div>
            TarkPay offers you different types of E-commerce platform plugins:
        </div>
        <p style="font-style: italic; font-weight: bold; font-size: small;">NB! All plugins are updated to v2 and if you are using plugin version v1 then you should update your plugin.</p>

        <div>
            <ul>
                <li>Wordpress</li>
                <li>Magento</li>
                <li>Prestashop</li>
                <li>OpenCart</li>
            </ul>
        </div>
        <p class="pb-0 mb-0 mt-6">
            If you want to test the solution with Sandbox mode, the best way is to use LHV or Swedbank as a payment
            option, as it does not require you to register a special account.
        </p>
        <p class="pb-0 mb-0">In LHV, choose the option "Sandbox" and click on Enter.</p>
        <p>In Swedbank, username: tarkpay and password: tarkpay.</p>
    </div>
</template>

<script>
export default {
    name: "welcome-page"
};
</script>

<style scoped></style>
